import { useEffect } from 'react';
import {
  IonPage, IonHeader, IonToolbar, IonTitle, IonContent, IonButtons, IonMenuButton,
  IonSegment, IonSegmentButton, IonLabel, IonSpinner, IonButton,
} from '@ionic/react';
import { downloadOutline } from 'ionicons/icons';
import { IonIcon as IonIcon } from '@ionic/react';
import { useTranslation } from 'react-i18next';
import { useAnalyticsStore } from '@/store/data.store';
import KpiTile from '@/components/KpiTile';
import Sparkline from '@/components/Sparkline';
import PlatformChip from '@/components/PlatformChip';
import { METRIC_LABELS_FALLBACK } from '@/lib/metricLabels';

const numberFormat = new Intl.NumberFormat('en');

export default function AnalyticsPage() {
  const { t } = useTranslation();
  const dashboard = useAnalyticsStore((s) => s.dashboard);
  const loading = useAnalyticsStore((s) => s.loading);
  const days = useAnalyticsStore((s) => s.days);
  const setDays = useAnalyticsStore((s) => s.setDays);
  const loadDashboard = useAnalyticsStore((s) => s.loadDashboard);
  const exportCsv = useAnalyticsStore((s) => s.exportCsv);

  useEffect(() => {
    void loadDashboard();
  }, [loadDashboard]);

  const totals = dashboard?.totals ?? [];

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start"><IonMenuButton /></IonButtons>
          <IonTitle>{t('analytics.title')}</IonTitle>
          <IonButtons slot="end">
            <IonButton onClick={() => void exportCsv()}>
              <IonIcon slot="icon-only" icon={downloadOutline} />
            </IonButton>
          </IonButtons>
        </IonToolbar>
        <IonToolbar>
          <IonSegment value={String(days)} onIonChange={(event) => setDays(Number((event.target as HTMLIonSegmentElement).value))}>
            <IonSegmentButton value="7"><IonLabel>{t('analytics.last7Days')}</IonLabel></IonSegmentButton>
            <IonSegmentButton value="30"><IonLabel>{t('analytics.last30Days')}</IonLabel></IonSegmentButton>
            <IonSegmentButton value="90"><IonLabel>{t('analytics.last90Days')}</IonLabel></IonSegmentButton>
          </IonSegment>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        {loading && !dashboard ? (
          <div className="empty-state"><IonSpinner /></div>
        ) : (
          <div className="page-shell">
            <div className="kpi-grid">
              {totals.map((metric) => (
                <KpiTile key={metric.key} label={METRIC_LABELS_FALLBACK[metric.key] ?? metric.key} value={numberFormat.format(metric.total)} />
              ))}
            </div>

            <h6 className="section-title">{t('dashboard.performance')}</h6>
            <Sparkline points={(dashboard?.series ?? []).map((point) => point.engagements)} height={90} />

            <h6 className="section-title">{t('analytics.platforms')}</h6>
            {(dashboard?.platformBreakdown ?? []).map((row) => (
              <div key={row.platformId} className="dash-row">
                <PlatformChip platform={row.platformId} />
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: '0.85rem' }}>
                    {numberFormat.format(row.engagements)} · {row.posts} posts
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </IonContent>
    </IonPage>
  );
}

function IonIconSlot() {
  return null;
}
